var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTitleContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10623_106373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8868 8H3.11855C2.29189 8.00141 1.4995 8.33043 0.914961 8.91496C0.330426 9.4995 0.00141188 10.2919 0 11.1185L0 18.68C0.00141188 19.5066 0.330426 20.299 0.914961 20.8835C1.4995 21.4681 2.29189 21.7971 3.11855 21.7985H26.8868C27.713 21.7971 28.5048 21.4679 29.0885 20.8832C29.6722 20.2985 30 19.5061 30 18.68V11.1185C30 10.2924 29.6722 9.49997 29.0885 8.91529C28.5048 8.3306 27.713 8.00141 26.8868 8ZM1.1748 18.68V11.1185C1.1748 10.603 1.37958 10.1086 1.74411 9.74411C2.10863 9.37958 2.60303 9.1748 3.11855 9.1748H10.7227V20.629H3.11855C2.86284 20.629 2.60965 20.5786 2.37347 20.4806C2.13729 20.3826 1.92278 20.2389 1.74222 20.0579C1.56165 19.8768 1.41859 19.6619 1.32122 19.4254C1.22385 19.189 1.17409 18.9357 1.1748 18.68ZM28.8359 18.68C28.8359 19.1945 28.6318 19.6881 28.2685 20.0525C27.9051 20.4169 27.4121 20.6223 26.8975 20.6237H11.9028V9.1748H26.8868C27.1425 9.17409 27.3958 9.22385 27.6323 9.32122C27.8687 9.41859 28.0836 9.56165 28.2647 9.74222C28.4457 9.92278 28.5894 10.1373 28.6874 10.3735C28.7854 10.6096 28.8359 10.8628 28.8359 11.1185V18.68Z",
    fill: "#B1B5C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10623_106373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 13.8038,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTitleContent);
export default __webpack_public_path__ + "static/media/ic_title_content.d216fdd0730e965f0cf1d6b1c6d38b2c.svg";
export { ForwardRef as ReactComponent };